import { contractConstants } from "../constants/contractConstants";
import { contractService } from "../../services/API/contractService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const contractActions = {
  add_contract,
  add_product,
  add_auction,
  getContractList,
  getContractNotExecutedList,
  deleteContract,
  getContractDetails,
  getProductDetails,
  getAuctionDetails,
  update_contract,
  update_product,
  update_auction,
  clone_contract,
  clone_product_detail,
  clone_auction_detail,
  clone_contract_non_executed,
  clone_product,
  clone_auction,
  executeContract,
  uploadPhysicalContracts,
  sendContractMail,
  getContractPoposal,
  ContractType,
};

export const add_contract = (postData) => {
  return (dispatch) => {
    contractService.add_contract(postData).then(
      (data) => {
        dispatch(success(data));
        history.push("/contractList");
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.ADD_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.ADD_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.ADD_CONTRACT_FAILURE, error };
  }
};

export const add_product = (postData) => {
  return (dispatch) => {
    contractService.add_product(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.ADD_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.ADD_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.ADD_CONTRACT_FAILURE, error };
  }
};

export const add_auction = (postData) => {
  return (dispatch) => {
    contractService.add_auction(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.ADD_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.ADD_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.ADD_CONTRACT_FAILURE, error };
  }
};

export const sendContractMail = (postData) => {
  return (dispatch) => {
    contractService.sendContractMail(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.SEND_MAIL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.SEND_MAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.SEND_MAILFAILURE, error };
  }
};

export const update_contract = (postData) => {
  return (dispatch) => {
    contractService.update_contract(postData).then(
      (data) => {
        dispatch(success(data));
        history.push("/contractList");
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.UPDATE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.UPDATE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.UPDATE_CONTRACT_FAILURE, error };
  }
};

export const update_product = (postData) => {
  return (dispatch) => {
    contractService.update_product(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.UPDATE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.UPDATE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.UPDATE_CONTRACT_FAILURE, error };
  }
};

export const update_auction = (postData) => {
  return (dispatch) => {
    contractService.update_auction(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.UPDATE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.UPDATE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.UPDATE_CONTRACT_FAILURE, error };
  }
};

export const clone_contract = (postData) => {
  return (dispatch) => {
    contractService.clone_contract(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.CLONE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.CLONE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.CLONE_CONTRACT_FAILURE, error };
  }
};

export const clone_product_detail = (postData) => {
  return (dispatch) => {
    contractService.clone_product_detail(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.CLONE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.CLONE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.CLONE_CONTRACT_FAILURE, error };
  }
};

export const clone_auction_detail = (postData) => {
  return (dispatch) => {
    contractService.clone_auction_detail(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.CLONE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.CLONE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.CLONE_CONTRACT_FAILURE, error };
  }
};

export const clone_contract_non_executed = (postData) => {
  return (dispatch) => {
    contractService.clone_contract_non_executed(postData).then(
      (data) => {
        dispatch(success(data));
        history.push("/contractList");
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_REQUEST,
      data,
    };
  }
  function success(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_FAILURE,
      error,
    };
  }
};

export const clone_product = (postData) => {
  return (dispatch) => {
    contractService.clone_product(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_REQUEST,
      data,
    };
  }
  function success(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_FAILURE,
      error,
    };
  }
};

export const clone_auction = (postData) => {
  return (dispatch) => {
    contractService.clone_auction(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_REQUEST,
      data,
    };
  }
  function success(data) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: contractConstants.CLONE_CONTRACT_NON_EXECUTED_FAILURE,
      error,
    };
  }
};

export const getContractList = (formData) => {
  return (dispatch) => {
    contractService.getContractList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACT_FAILURE, error };
  }
};

export const getContractNotExecutedList = (formData) => {
  return (dispatch) => {
    contractService.getContractNotExecutedList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACT_NOT_EXECUTED_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACT_NOT_EXECUTED_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACT_NOT_EXECUTED_FAILURE, error };
  }
};

export const deleteContract = (contractIdAsParams) => {
  return (dispatch) => {
    contractService.deleteContract(contractIdAsParams).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.DELETE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.DELETE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.DELETE_CONTRACT_FAILURE, error };
  }
};

export const removeChildContract = (contractIdAsParams) => {
  return (dispatch) => {
    contractService.removeChildContract(contractIdAsParams).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.DELETE_CONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.DELETE_CONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.DELETE_CONTRACT_FAILURE, error };
  }
};

export const getContractDetails = (contractIdParams) => {
  return (dispatch) => {
    contractService.getContractDetails(contractIdParams).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACTDETAIL_FAILURE, error };
  }
};

export const getProductDetails = (contractIdParams) => {
  return (dispatch) => {
    contractService.getProductDetails(contractIdParams).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACTDETAIL_FAILURE, error };
  }
};

export const getAuctionDetails = (contractIdParams) => {
  return (dispatch) => {
    contractService.getAuctionDetails(contractIdParams).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACTDETAIL_FAILURE, error };
  }
};

export const getContractPoposal = (contractIdParams) => {
  return (dispatch) => {
    contractService.getContractPoposal(contractIdParams).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.GET_CONTRACTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.GET_CONTRACTDETAIL_FAILURE, error };
  }
};

export const executeContract = (postData) => {
  return (dispatch) => {
    contractService.executeContract(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.POST_CONTRACTEXECUTE_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.POST_CONTRACTEXECUTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.POST_CONTRACTEXECUTE_FAILURE, error };
  }
};

export const uploadPhysicalContracts = (postData) => {
  return (dispatch) => {
    dispatch(request(postData));
    contractService.uploadPhysicalContracts(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.POST_CONTRACTPHYSICAL_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.POST_CONTRACTPHYSICAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.POST_CONTRACTPHYSICAL_FAILURE, error };
  }
};

export const ContractType = (postData) => {
  return (dispatch) => {
    //dispatch(request(postData));
    contractService.ContractType(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: contractConstants.POST_CONTRACTTYPE_REQUEST, data };
  }
  function success(data) {
    return { type: contractConstants.POST_CONTRACTTYPE_SUCCESS, data };
  }
  function failure(error) {
    return { type: contractConstants.POST_CONTRACTTYPE_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/contractActions.js